import assign from 'lodash.assign';
export class CodeType {
    constructor(init) {
        assign(this, init);
    }
    listID;
    listName;
    listAgencyID;
    listAgencyName;
    listVersionID;
    listURI;
    listSchemeURI;
    name;
    languageID;
    value;
}
